import {z} from '@hono/zod-openapi';

import {amount} from './amount';
import {count} from './count';
import {DeadStockBucketSchema} from './DeadStockBucketSchema';

export const DeadStockMonthSchema = z
  .object({
    month: z.string().regex(/^\d{4}-\d{2}$/),
    asOf: z.string().date(),
    bucket: DeadStockBucketSchema,
    // NULL when the bucket holds a card with an unpriced movement - unknown, not zero.
    purchaseValue: amount.nullable(),
    cardCount: count,
  })
  .openapi('DeadStockMonth');

export type DeadStockMonth = z.infer<typeof DeadStockMonthSchema>;
